import React from "react";
import { useTranslation } from "react-i18next";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="py-8 bg-gray-800 text-white text-center">
      <div className="container mx-auto px-5">
        <p className="text-sm">{t("footer.copyright")}</p>
      </div>
    </footer>
  );
};

export default Footer;
